var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-a-placeholder"},[_c('div',{staticClass:"c-a-placeholder-text"},[_vm._v("\n    "+_vm._s(_vm.capitalizeAllWords(_vm.$t('advertising space')))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }